module.exports = __webpack_public_path__ + "db0ccc7b15d456ca627479b6bcad7f52.jpg";